import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { getWebpSrc, getImageType } from '../utils/images';
import withIframeStyle from '../containers/WithIframeStyle';
import { getRestaurantMenuModalStyle } from '../utils/iframe-style-helper';
import './images-slider-modal.scss';
var ImagesSliderModal = function (props) {
    var iframeStyle = props.iframeStyle, images = props.images, imgClassName = props.imgClassName, toggle = props.toggle, title = props.title, prefix = props.prefix, hasWebp = props.hasWebp;
    return React.createElement(Modal, { isOpen: true, toggle: toggle, style: iframeStyle, className: "image-slider-modal" },
        React.createElement(ModalHeader, { toggle: toggle }, title),
        React.createElement(ModalBody, { className: "p-0" },
            React.createElement("div", { id: "carouselExampleCaptions", className: "carousel slide", "data-ride": "carousel" },
                React.createElement("ol", { className: "carousel-indicators" }, images.map(function (img, index) { return (React.createElement("li", { "data-target": "#carouselExampleCaptions", key: img.src || img, "data-slide-to": index, className: index === 0 ? 'active' : '' })); })),
                React.createElement("div", { className: "carousel-inner" }, images.map(function (img, index) {
                    var filePath = img.src || img;
                    return React.createElement("div", { className: "carousel-item ".concat(index === 0 ? 'active' : ''), key: filePath },
                        React.createElement("picture", null,
                            hasWebp ? React.createElement("source", { srcSet: "".concat(prefix).concat(getWebpSrc(filePath)), type: "image/webp" }) : null,
                            React.createElement("source", { srcSet: "".concat(prefix).concat(filePath), type: getImageType(filePath) }),
                            React.createElement("img", { className: imgClassName, src: "".concat(prefix).concat(filePath), alt: title })));
                })),
                images && (images.length > 1)
                    ? React.createElement(React.Fragment, null,
                        React.createElement("a", { className: "carousel-control-prev", href: "#carouselExampleCaptions", role: "button", "data-slide": "prev" },
                            React.createElement("span", { className: "carousel-control-prev-icon", "aria-hidden": "true" }),
                            React.createElement("span", { className: "sr-only" }, "Previous")),
                        React.createElement("a", { className: "carousel-control-next", href: "#carouselExampleCaptions", role: "button", "data-slide": "next" },
                            React.createElement("span", { className: "carousel-control-next-icon", "aria-hidden": "true" }),
                            React.createElement("span", { className: "sr-only" }, "Next")))
                    : null)));
};
ImagesSliderModal.displayName = 'ImagesSliderModal';
ImagesSliderModal.propTypes = {
    images: PropTypes.array.isRequired,
    imgClassName: PropTypes.string,
    hasWebp: PropTypes.bool,
    prefix: PropTypes.string,
    title: PropTypes.string.isRequired,
    toggle: PropTypes.func.isRequired,
};
ImagesSliderModal.defaultProps = {
    imgClassName: '',
    prefix: '',
    hasWebp: true,
};
export default withIframeStyle(ImagesSliderModal, getRestaurantMenuModalStyle, { repaintOnInit: true });
